<template>
    <v-card style="height: calc(100vh - 142px)">
        <iframe :src="docsUrl" style="width: 100%; height: 100%; border: none; display: block"></iframe>
    </v-card>
</template>

<script>
import { i18n } from '@/plugins/i18n';
import { computed } from '@vue/composition-api';


export default {
    setup() {

        const docsUrl = computed(() => {
            let path = i18n.locale !== 'fi' ? i18n.locale : '';
            return new URL(path, process.env.VUE_APP_DOCS_URL).toString();
        });

        return { docsUrl }
    },
}
</script>
